import { gsap } from 'gsap';
import { getKeyboardFocusableElements } from '../utils';
import barba from '@barba/core';
import ProgramEvent from './ProgramEvent';

export default class EventsHeader {
	constructor(elm, modules) {
		this.elm = elm;
		this.modules = modules;

		this.filterOpen = false;
		this.filterAnimating = false;

		this.filter = this.elm.querySelector('[data-events-filter]');
		this.collapse = this.elm.querySelector('[data-events-filter-inner]');
		this.form = this.elm.querySelector('[data-filter-form]');
		this.getKeyboardFocusableElements = getKeyboardFocusableElements(this.collapse);

		this.eventsFilterButton = this.elm.querySelector('[data-events-filter-button]');
		if(this.eventsFilterButton) {
			this.eventsFilterButton.addEventListener('click', this.toggleFilter.bind(this));
		}

		this.clearButton = this.elm.querySelector('[data-clear]');
		this.tabTriggers = this.elm.querySelectorAll('[data-tab-trigger]');

		this.clearButton.addEventListener('click', (e) => {
			this.form.reset();
			this.filterEvents();
			this.closeFilter();
		});

		this.form.addEventListener('submit', (e) => {
			e.preventDefault();
			this.filterEvents();
			this.closeFilter();
		});

		this.tabTriggers.forEach((tabTrigger) => {
			tabTrigger.addEventListener('click', (e) => {
				e.preventDefault();

				const el = document.createElement('div');
				el.setAttribute('data-barba-history', 'replace');
				barba.history.add(tabTrigger.href, el);

				this.activateTab(tabTrigger.hash);
			});
		});

		// Set initial tabindex
		this.getKeyboardFocusableElements.forEach((element) => (element.tabIndex = -1));

		this.hideEventDates();

		if (window.location.hash) {
			this.activateTab(window.location.hash);
		}
	}

	activateTab(targetString) {
		if (!targetString) {
			return;
		}

		const tabTrigger = document.querySelector(`[href="${targetString}"]`);

		if (!tabTrigger) {
			return;
		}

		this.tabTriggers.forEach((trigger) => {
			trigger.setAttribute('aria-expanded', false);
			trigger.classList.remove('is-active');
		});
		tabTrigger.setAttribute('aria-expanded', true);
		tabTrigger.classList.add('is-active');

		const tab = document.querySelector(`[data-tab]${targetString}`);

		if (!tab) {
			return;
		}

		document.querySelectorAll('[data-tab]').forEach((tab) => tab.classList.remove('is-active'));
		tab.classList.add('is-active');
	}

	hideEventDates() {
		document.querySelectorAll('.c-events__list').forEach((list) => {
			const events = list.querySelectorAll('.c-events__list [data-event]:not(.is-hidden)');
			let prevDate = '';

			events.forEach((event, index) => {
				if (event.dataset.startDate == prevDate) {
					event.classList.add('c-event--same-date');
				} else {
					event.classList.remove('c-event--same-date');
				}

				prevDate = event.dataset.startDate;
			});
		});
	}

	filterEvents() {
		const formData = new FormData(this.collapse);
		const classes = Array.from(formData.entries()).map(([key, value]) => `.${key}-${value}`);
		const filterString = classes.join('');

		document.querySelectorAll('.c-events__list').forEach((list) => {
			const items = list.querySelectorAll('[data-event]');
			let hidden = 0;

			items.forEach((event) => {
				if (!filterString || event.matches(filterString)) {
					event.classList.remove('is-hidden');
				} else {
					event.classList.add('is-hidden');
					hidden++;
				}
			});

			if (hidden == items.length) {
				list.classList.add('is-empty');
			} else {
				list.classList.remove('is-empty');
			}
		});

		this.hideEventDates();

		this.modules.forEach((module) => {
			if (module instanceof ProgramEvent) {
				module.closeDetails(true);
			}
		});
	}

	toggleFilter() {
		if (this.filterAnimating) {
			return;
		}
		if (this.filterOpen) {
			this.closeFilter();
		} else {
			this.openFilter();
		}
	}

	openFilter() {
		const tl = gsap.timeline({
			onStart: () => {
				this.filterAnimating = true;
				this.elm.classList.add('filter-open');
				this.filter.classList.add('is-open');
			},
			onComplete: () => {
				this.filterAnimating = false;
				this.filterOpen = true;
			},
		});

		tl.fromTo(
			this.filter,
			{
				height: 0,
			},
			{
				height: this.collapse.scrollHeight,
				clearProps: 'height',
				ease: 'power2.inOut',
				duration: 1,
			}
		);

		tl.fromTo(
			this.collapse,
			{
				opacity: 0,
			},
			{
				opacity: 1,
				ease: 'sine.inOut',
				duration: 0.8,
			},
			0.6
		);

		this.getKeyboardFocusableElements.forEach((element) => element.removeAttribute('tabindex'));
	}

	closeFilter() {
		const tl = gsap.timeline({
			onStart: () => {
				this.filterAnimating = true;
				this.filter.classList.remove('is-open');
				this.elm.classList.remove('filter-open');
			},
			onComplete: () => {
				this.filterAnimating = false;
				this.filterOpen = false;
			},
		});

		tl.fromTo(
			this.collapse,
			{
				opacity: 1,
			},
			{
				opacity: 0,
				ease: 'sine.inOut',
				duration: 0.4,
			}
		);

		tl.fromTo(
			this.filter,
			{
				height: this.collapse.scrollHeight,
			},
			{
				height: 0,
				clearProps: 'height',
				ease: 'power2.inOut',
				duration: 0.8,
			},
			0.2
		);

		this.getKeyboardFocusableElements.forEach((element) => (element.tabIndex = -1));
	}

	destroy() {
		//
	}
}
